import { TableHead } from '@/components/ui/table'
import type { SortDirection } from '@backend/schemas'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

interface SortableTableHeadProps<F extends string> {
  label: string
  field: F
  sortField: F
  sortDir: SortDirection
  onSort: (field: F) => void
  // Search results are always ordered by the searched field, so sorting is disabled while searching
  disabled?: boolean
}

export const SortableTableHead = <F extends string>({
  label,
  field,
  sortField,
  sortDir,
  onSort,
  disabled,
}: SortableTableHeadProps<F>) => {
  if (disabled) return <TableHead title="Sortering är inte tillgänglig vid sökning">{label}</TableHead>

  return (
    <TableHead className="cursor-pointer select-none" onClick={() => onSort(field)}>
      <span className="flex items-center gap-1">
        {label}
        {sortField === field ? (
          sortDir === 'asc' ? (
            <ArrowUp className="h-3 w-3" />
          ) : (
            <ArrowDown className="h-3 w-3" />
          )
        ) : (
          <ArrowUpDown className="h-3 w-3 opacity-30" />
        )}
      </span>
    </TableHead>
  )
}
